import { render, staticRenderFns } from "./UserTab.vue?vue&type=template&id=78439464&scoped=true"
import script from "./UserTab.vue?vue&type=script&lang=js"
export * from "./UserTab.vue?vue&type=script&lang=js"
import style0 from "./UserTab.vue?vue&type=style&index=0&id=78439464&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78439464",
  null
  
)

export default component.exports